import { fromJS } from 'immutable';
import actionTypes from 'constants/appConstants';

export const initialState = fromJS({
  globalError: null,
  globalInfo: null,
});

const appReducer = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.SHOW_APP_FATAL_ERROR:
      return state.set('globalError', action.payload);
    case actionTypes.HIDE_APP_FATAL_ERROR:
      return state.set('globalError', null);
    case actionTypes.SHOW_APP_INFO:
      return state.set('globalInfo', action.payload);
    case actionTypes.HIDE_APP_INFO:
      return state.set('globalInfo', null);
    default:
      return state;
  }
};

export default appReducer;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/reducers/appReducer.js